module.exports = __webpack_public_path__ + "img/marvel-api.e3de88f1.png";